import { Box, Button } from '@apia/theme';
import { IconButton } from '../../../common';
import { TTreeLabelRenderer } from '../../../common/generic/tree/types';
import { TSearchNodeProps } from './SearchResult';

const LeafsAsLinkRenderer: TTreeLabelRenderer<TSearchNodeProps> = (props) => {
  return (
    <Box as="span" className="menu__element">
      <Button
        className="menu__openTask"
        data-test-id={`open-functionality-${(
          props.nodeProps?.showLabel ?? props.label
        )
          .split(/(\) *)/g)
          .slice(2)
          .join('')}`}
        tabIndex={-1}
        {...window.getVariant('inherit')}
      >
        {props.nodeProps?.showLabel ?? props.label}
      </Button>
      {props.nodeProps?.isFavorite !== undefined && (
        <IconButton
          tabIndex={props.isFocused ? 0 : -1}
          {...window.getVariant('icon-only')}
          className={`menu__toggleFavoriteButton ${
            props.nodeProps.isFavorite ? 'favorite' : ''
          }`}
          icon="Star"
          onClick={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();
          }}
          onMouseDown={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            props.nodeProps.onFavoriteClick?.();
          }}
        />
      )}
    </Box>
  );
};

export default LeafsAsLinkRenderer;
